module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container logged-out-content"
  }, [_c('div', {
    staticClass: "block form-md"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content text-bold text-center h4"
  }, [_vm._v("\n      Please select the product you would like to sign-up for:\n    ")]), _vm._v(" "), _c('context-selector'), _vm._v(" "), _c('keep-alive', [_c(_vm.currentForm, {
    tag: "component"
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/Patient-Icon.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('h2', [_vm._v("Signup")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b6a3796"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/SignUp.vue
// module id = 648
// module chunks = 5